module.exports = __webpack_public_path__ + "img/bmcl_gallery5.0360822d.jpg";